<script lang="ts">
  import { user } from "$lib/identity/user";
  import { themeStore } from "$routes/(microsites)/gpu-glossary/_lib/gpu-glossary";

  $: isLoggedIn = $user?.loggedIn ?? false;
</script>

<a
  class="flex items-center gap-x-1 rounded-full px-3 py-1 hover:ring-1 hover:ring-(--ring-color)"
  style:background-color={$themeStore.secondary[100]}
  style:--ring-color={$themeStore.primary[60]}
  style:color={$themeStore.primary[100]}
  href={isLoggedIn ? "/apps" : "/signup"}
>
  {isLoggedIn ? "Dashboard" : "Deploy on GPUs"}
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.80065 3.8573L4.42917 3.22878L5.68625 4.48586L6.94335 3.22876L8.20041 4.48583L0.657938 12.0283L1.91504 13.2854L9.45751 5.74292L10.7146 7.00002L9.45751 8.25712L10.7145 9.51416L10.086 10.1427L11.3431 11.3998L13.2287 9.51416L11.9716 8.25706L13.2287 6.99996L11.9717 5.74292L13.2287 4.48588L12.6002 3.85731L13.2287 3.22873L12.6002 2.60021L13.2287 1.97169L11.9716 0.714591L11.3431 1.34311L10.7146 0.71459L10.086 1.34317L9.45748 0.714626L8.20044 1.97167L6.94336 0.714584L5.68627 1.97168L4.42919 0.714608L2.54357 2.60023L3.80065 3.8573Z"
      fill="currentColor"
    />
  </svg>
</a>
